import { useEffect, useRef } from "react";
import { Text, Transformer } from "react-konva";

export type TextLayerAttr = {
  id: string;
  text: string;
  font: string;
  fontSize: number;
  color: string;
  textSpacing: number;
  fontWeight: "normal" | "medium" | "600" | "bold";
  textAlign: "left" | "center" | "right";
  lineHeight: number;
  textWidth: number;
  x: number;
  y: number;
}


type Props = {
  textAttr: TextLayerAttr,
  isSelected: boolean,
  onSelect: () => void,
  onChange: (newTextAttr: TextLayerAttr) => void
}

const TextLayer = ({ textAttr, onChange, onSelect, isSelected }: Props) => {

  const textRef = useRef<any>(null);
  const transformerRef = useRef<any>(null);

  useEffect(() => {
    if (isSelected && transformerRef.current && textRef.current) {
      const node = textRef.current;
      transformerRef.current.nodes([node]);
      transformerRef.current.forceUpdate();
      transformerRef.current.getLayer()?.batchDraw();
    }
  }, [textAttr, isSelected]);


  return (
    <>
      <Text
        ref={textRef}
        onClick={onSelect}
        onTap={onSelect}
        text={textAttr.text}
        fontFamily={textAttr.font}
        fontSize={textAttr.fontSize}
        fill={textAttr.color}
        letterSpacing={textAttr.textSpacing}
        fontStyle={textAttr.fontWeight}
        align={textAttr.textAlign}
        width={textAttr.textWidth}
        lineHeight={textAttr.lineHeight}
        x={textAttr.x}
        y={textAttr.y}
        draggable
        onDragEnd={(e) => {
          onChange({
            ...textAttr,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={() => {
          const node = textRef.current;
          const scaleX = node.scaleX();
          const newWidth = node.width() * scaleX;

          node.scaleX(1);
          node.scaleY(1);

          onChange({
            ...textAttr,
            x: node.x(),
            y: node.y(),
            textWidth: Math.max(50, newWidth),
          });
        }}
        hitStrokeWidth={20}
      />
      {isSelected && (
        <Transformer
          ref={transformerRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 20 || newBox.height < 20) return oldBox;
            return newBox;
          }}
          rotateEnabled={false}
          keepRatio={true}
          // Make handles larger for mobile
          anchorSize={12}
          borderStroke="#007bff"
          borderStrokeWidth={2}
        />
      )}

    </>
  )
}

export default TextLayer;
